import http from "@/api/http.js";

export function saveImageToProduct(code, imageUrl) {
  return http.post("images", { code, product_url: imageUrl });
}
export function deleteImageApi(code, image) {
  return http.post("images/remove", { code, image });
}
export function setMainImageApi(code, image) {
  return http.post("images/set_main", { code, image });
}
export function getCustomImagesApi(code) {
  return http.get(`images/custom/${code}`);
}

export function copyImageFamily(code, id) {
  return http.post(`images/copy_image_family`, { code, id });
}

export function getImagesLogs(code) {
  return http.get(`images/logs/${code}`);
}
/**
 * Interface Item {
 *  code: String,
 *  quantity: Number,
 * }
 *
 * @param String kitCode
 * @param Item[] items
 * @returns
 */
export function generateKitImage(kitCode, items) {
  const params = {
    kitCode,
    items
  };
  return http.post(`/images/generate_kit_image`, params).then(res => res.data);
}
